/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Standard (Standard)
 * 
 * 401130001 = Bericht (Bericht)
 * 
 * 401130002 = Abschluss (Abschluss)
 * 
 * 401130003 = Gutachten (Gutachten)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceTypphase {
 Standard = 401130000,
 Bericht = 401130001,
 Abschluss = 401130002,
 Gutachten = 401130003
}

marker([
    "Enum.GlobalEnumsAceTypphase.Standard",
    "Enum.GlobalEnumsAceTypphase.Bericht",
    "Enum.GlobalEnumsAceTypphase.Abschluss",
    "Enum.GlobalEnumsAceTypphase.Gutachten"
]);

export namespace GlobalEnumsAceTypphase
{
    class DataSets
    {
        static GlobalEnumsAceTypphaseDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Standard", 401130000, "Standard"),
            new EnumValue("Bericht", 401130001, "Bericht"),
            new EnumValue("Abschluss", 401130002, "Abschluss"),
            new EnumValue("Gutachten", 401130003, "Gutachten"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceTypphaseDataSet;
    }
}
